import { render, staticRenderFns } from "./DetailsProjectModal.vue?vue&type=template&id=c946f826&"
import script from "./DetailsProjectModal.vue?vue&type=script&lang=js&"
export * from "./DetailsProjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports